// extracted by mini-css-extract-plugin
export var address = "EventPageHeader-module--address--aR12u";
export var categories = "EventPageHeader-module--categories--w7Qcf";
export var category = "EventPageHeader-module--category--HloEm";
export var component = "EventPageHeader-module--component--OyjfS";
export var title = "EventPageHeader-module--title--iHYi1";